// extracted by mini-css-extract-plugin
export default {"center":"Header_center__TS8Gk","headerText":"Header_headerText__Xrh8t"};